import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import BarChartIcon from '@mui/icons-material/BarChart';
import DeleteIcon from '@mui/icons-material/Delete';
import '../../styles/Button.css'; // optional for shared styles
import { BotItem } from '../../api/types';
import EmptyBotList from './EmptyBotList';
import CancelIcon from '@mui/icons-material/Cancel';

type BotListProps = {
  bots: BotItem[];
  onDelete: (id: string) => void;
  onViewAnalytics: (id: string) => void;
};

const BotList: React.FC<BotListProps> = ({ bots, onDelete, onViewAnalytics }) => {
  const handleCopy = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (err) {
    }
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', margin: '0' }}>
        {bots.length ? 
      bots.map((bot) => (
        <div
          key={bot.id}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            border: '1px solid #e0e0e0',
            borderRadius: '16px',
            padding: '16px',
            marginBottom: '16px',
            transition: 'box-shadow 0.2s ease-in-out',
            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
            fontFamily: 'Montserrat',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '18px', fontWeight: 600 }}>{bot.name}</div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                Type: {bot.type} · Focus: {bot.focus}
              </div>
              {bot.enabled ? null : 
              <Tooltip title="Bot is disabled due to billing, go to Account to view">
                <CancelIcon style={{ color: '#e74c3c', verticalAlign: 'middle', cursor: 'help', marginRight: '5px' }} />
              </Tooltip> }
              <a
                href={bot.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: '14px',
                  color: 'var(--primary)',
                  textDecoration: 'none',
                  wordBreak: 'break-all',
                }}
              >
                {bot.url}
              </a>
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <Tooltip title="Copy URL">
                <IconButton
                  onClick={() => handleCopy(bot.url)}
                  style={{ transition: 'transform 0.15s ease' }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
                >
                  <ContentCopyIcon style={{ color: 'var(--primary)' }} />
                </IconButton>
              </Tooltip>

              <Tooltip title="View Analytics">
                <IconButton
                  onClick={() => onViewAnalytics(bot.id)}
                  style={{ transition: 'transform 0.15s ease' }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
                >
                  <BarChartIcon style={{ color: '#2ecc71' }} />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete Bot">
                <IconButton
                  onClick={() => onDelete(bot.id)}
                  style={{ transition: 'transform 0.15s ease' }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1.0)')}
                >
                  <DeleteIcon style={{ color: '#e74c3c' }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      )) : <EmptyBotList></EmptyBotList> }
    </div>
  );
};

export default BotList;
